import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const StyledButton = styled.a`
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  outline: 0;
  text-decoration: none;

  height: ${props => (props.small ? '2.25rem' : '3rem')};
  font-size: ${props => (props.small ? '0.75rem' : '1rem')};
  padding: 0 ${props => (props.small ? '1.25rem' : '2rem')};
  border-radius: ${props =>
    props.small ? '3px' : 'var(--border-radius-button)'};
  font-weight: var(--font-weight-boldest);
  cursor: pointer;
  text-decoration: none;

  transition-property: background-color, border-color, color, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  ${props => {
      const { variant } = props

      let fgColor
      let bgColor
      let borderColor
      let bgColorHover
      let borderColorHover

      switch (variant) {
        case 'primary':
          bgColor = 'var(--color-primary)'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = 'var(--color-primary-hover)'
          fgColor = '#ffffff'
          break
        case 'secondary':
          bgColor = 'var(--color-secondary)'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = 'var(--color-secondary-hover)'
          fgColor = '#ffffff'
          break
        case 'tertiary':
          bgColor = 'var(--color-tertiary)'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = 'var(--color-tertiary-hover)'
          fgColor = '#ffffff'
          break
        case 'facebook':
          bgColor = '#3b5998'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = bgColor
          fgColor = '#ffffff'
          break
        case 'google':
          bgColor = '#ea4335'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = bgColor
          fgColor = '#ffffff'
          break
        default:
          bgColor = 'var(--color-background-primary)'
          bgColorHover = bgColor
          fgColor = 'var(--color-primary)'
          borderColor = fgColor
          borderColorHover = borderColor
          break
      }

      return css`
        background-color: ${bgColor};
        color: ${fgColor} !important;
        border: 1px solid ${borderColor};

        &:hover {
          background-color: ${bgColorHover};
          border-color: ${borderColorHover};
        }

        &:disabled {
          background-color: ${bgColor};
          border-color: ${borderColor};
        }
      `
    }}
    :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const IconWrapper = styled.span`
  display: flex;
  margin-right: 1rem;
  font-size: 1.25em;
  align-items: center;
  justify-content: center;
`

const LabelWrapper = styled.span`
  flex: auto;
  text-align: center;
  white-space: nowrap;
`

function ExternalLinkButton(props) {
  const { children, variant, icon, small = false, ...theProps } = props

  return (
    <StyledButton {...theProps} variant={variant} icon={icon} small={small}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <LabelWrapper>{children}</LabelWrapper>
    </StyledButton>
  )
}

ExternalLinkButton.defaultProps = {
  children: null,
  icon: null,
}

ExternalLinkButton.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string.isRequired,
  small: PropTypes.bool,
  icon: PropTypes.element,
}

export default ExternalLinkButton
